export const categoryList = [
	{category: 'Mobiles'},
	{category: 'Computers and Laptops'},
	{category: 'Mobile Accessories'},
	{category: 'Computer Peripherals'},
	{category: 'Audio Devices'},
	{category: 'Camera and Accessories'},
	{category: 'Laptop Accessories'},
	{category: 'Smart Wearables'},
	{category: 'Tablets'},
	{category: 'Storage'},
	{category: 'Gaming Consoles'},
	{category: 'Health and Personal Care'},
	{category: 'GPS and Navigation'},
	{category: 'Gaming Accessories'},
	{category: 'eBook Readers and Accessories'},
	{category: 'Security and Surveillance'},
	{category: 'Car and Vehicle Electronics'},
	{category: "Television and Accessories"},

	{category: 'Men\'s Clothing'},
	{category: 'Women\'s Clothing'},
	{category: 'Kids Clothing'},
	{category: 'Boys\' Clothing'},
	{category: 'Girls\' Clothing'},
	{category: 'Baby Clothing'},
	{category: 'Clothing Accessories'},
	{category: 'Cloth Materials'},

	{category: 'Home Décor'},
	{category: 'Tools and Utility'},
	{category: 'Lightning and Electricals'},
	{category: 'Cleaning and Bath'},
	{category: 'Bedding'},
	{category: 'Vacuums and Floor Care'},
	{category: 'Irons and Steamers'},
	{category: 'Home Appliances'},

	{category: 'Air Conditioners'},
	{category: 'Air Coolers'},
	{category: 'Washing Machines'},
	{category: 'Refrigerators'},
	{category: 'Heaters'},
	{category: 'Geyser'},
	{category: 'Air Purifiers'},
	{category: 'Fan'},
	{category: 'Chimney'},

	{category: 'Car Electronics'},
	{category: 'Oils and Fluids'},
	{category: 'Paint and Paint Supplies'},
	{category: 'RV Parts and Accessories'},
	{category: 'Interior Accessories'},
	{category: 'Exterior Accessories'},
	{category: 'Lights and Lighting Accessories'},
	{category: 'Performance Parts and Accessories'},

	{category: 'Beds'},
	{category: 'Kids Furniture'},
	{category: 'Chairs'},
	{category: 'Tables'},
	{category: 'Wardrobes'},
	{category: 'Book Shelves'},
	{category: 'Shoe Racks'},
	{category: 'Recliners'},
	{category: 'TV units'},
	{category: 'Computer Tables'},
	{category: 'Cabinet Drawers'},
	{category: 'Cupboards'},

	{category: 'Building Supplies'},
	{category: 'Plumbing Tools'},
	{category: 'Welding and Soldering'},
	{category: 'Power and Hand Tools'},
	{category: 'Hardware'},
	{category: 'Electrical Tools'},
	{category: 'Kitchen and Bath Fixtures'},
	{category: 'Measuring and Layout Tools'},
	{category: 'Safety and Security Tools'},

	{category: 'Sports Equipments'},
	{category: 'Fitness Equipments'},
	{category: 'Outdoor Recreation'},

	{category: 'Academics'},
	{category: 'Literature and Fiction'},
	{category: 'Non-Fiction'},
	{category: 'Kids Books'},
	{category: 'E-learning'},

	{category: 'Staples'},
	{category: 'Snacks and Beverages'},
	{category: 'Dairy and Eggs'},
	{category: 'Packaged Food'},
	{category: 'Cooking Essentials'},

	{category: 'Dogs'},
	{category: 'Cats'},
	{category: 'Fish and Aquatic Pets'},
	{category: 'Birds'},
	{category: 'Reptiles and Amphibians'},
	{category: 'Small Animals'},
	{category: 'Horses'},

	{category: 'Stationery'},
	{category: 'Desk Organizers'},
	{category: 'NoteBooks and Diaries'},
	{category: 'Art Supplies'},
	{category: 'Office Equipments'},
	{category: 'Party Suppllies'},
	{category: 'Fancy Items'},
	{category: 'School Supplies'},

	{category: 'Soft Toys'},
	{category: 'Puzzles'},
	{category: 'Board Games'},
	{category: 'Baby Toys'},
	{category: 'Giftable Toys'},
	{category: 'Electronic Toys'},
	{category: 'Educational Toys'},

	{category: 'Watches'},
	{category: 'Shoes'},
	{category: 'Men\'s Jewelry'},
	{category: 'Women\'s Jewelry'},
	{category: 'Handbags'},
	{category: 'Wallets'},
	{category: 'Watch Accessories'},
	{category: 'Gloves and Mittens'},
	{category: 'Precious Jewelry'},
	{category: 'Belts'},
	{category: 'Sunglasses'},
	{category: 'Contact Lenses and Frames'},
	{category: 'Bags and Luggages'},

	{category: 'Utensils'},
	{category: 'Containers'},
	{category: 'Cookware'},
	{category: 'Kitchen Tools'},
	{category: 'Gas Stoves and Accessories'},
	{category: 'Kitchen Storage'},
	{category: 'Grinders and Juicers'},
	{category: 'Choopers, Cutters and Knives'},
];

export const subCategoryList = [
	{subCategory: 'Mobiles'},
	{subCategory: 'Computers and Laptops'},
	{subCategory: 'Mobile Accessories'},
	{subCategory: 'Computer Peripherals'},
	{subCategory: 'Audio Devices'},
	{subCategory: 'Camera and Accessories'},
	{subCategory: 'Laptop Accessories'},
	{subCategory: 'Smart Wearables'},
	{subCategory: 'Tablets'},
	{subCategory: 'Storage'},
	{subCategory: 'Gaming Consoles'},
	{subCategory: 'Health and Personal Care'},
	{subCategory: 'GPS and Navigation'},
	{subCategory: 'Gaming Accessories'},
	{subCategory: 'eBook Readers and Accessories'},
	{subCategory: 'Security and Surveillance'},
	{subCategory: 'Car and Vehicle Electronics'},
	{subCategory: "Television and Accessories"},

	{subCategory: 'Men\'s Clothing'},
	{subCategory: 'Women\'s Clothing'},
	{subCategory: 'Kids Clothing'},
	{subCategory: 'Boys\' Clothing'},
	{subCategory: 'Girls\' Clothing'},
	{subCategory: 'Baby Clothing'},
	{subCategory: 'Clothing Accessories'},
	{subCategory: 'Cloth Materials'},

	{subCategory: 'Home Décor'},
	{subCategory: 'Tools and Utility'},
	{subCategory: 'Lightning and Electricals'},
	{subCategory: 'Cleaning and Bath'},
	{subCategory: 'Bedding'},
	{subCategory: 'Vacuums and Floor Care'},
	{subCategory: 'Irons and Steamers'},
	{subCategory: 'Home Appliances'},

	{subCategory: 'Air Conditioners'},
	{subCategory: 'Air Coolers'},
	{subCategory: 'Washing Machines'},
	{subCategory: 'Refrigerators'},
	{subCategory: 'Heaters'},
	{subCategory: 'Geyser'},
	{subCategory: 'Air Purifiers'},
	{subCategory: 'Fan'},
	{subCategory: 'Chimney'},

	{subCategory: 'Car Electronics'},
	{subCategory: 'Oils and Fluids'},
	{subCategory: 'Paint and Paint Supplies'},
	{subCategory: 'RV Parts and Accessories'},
	{subCategory: 'Interior Accessories'},
	{subCategory: 'Exterior Accessories'},
	{subCategory: 'Lights and Lighting Accessories'},
	{subCategory: 'Performance Parts and Accessories'},

	{subCategory: 'Beds'},
	{subCategory: 'Kids Furniture'},
	{subCategory: 'Chairs'},
	{subCategory: 'Tables'},
	{subCategory: 'Wardrobes'},
	{subCategory: 'Book Shelves'},
	{subCategory: 'Shoe Racks'},
	{subCategory: 'Recliners'},
	{subCategory: 'TV units'},
	{subCategory: 'Computer Tables'},
	{subCategory: 'Cabinet Drawers'},
	{subCategory: 'Cupboards'},

	{subCategory: 'Building Supplies'},
	{subCategory: 'Plumbing Tools'},
	{subCategory: 'Welding and Soldering'},
	{subCategory: 'Power and Hand Tools'},
	{subCategory: 'Hardware'},
	{subCategory: 'Electrical Tools'},
	{subCategory: 'Kitchen and Bath Fixtures'},
	{subCategory: 'Measuring and Layout Tools'},
	{subCategory: 'Safety and Security Tools'},

	{subCategory: 'Sports Equipments'},
	{subCategory: 'Fitness Equipments'},
	{subCategory: 'Outdoor Recreation'},

	{subCategory: 'Academics'},
	{subCategory: 'Literature and Fiction'},
	{subCategory: 'Non-Fiction'},
	{subCategory: 'Kids Books'},
	{subCategory: 'E-learning'},

	{subCategory: 'Staples'},
	{subCategory: 'Snacks and Beverages'},
	{subCategory: 'Dairy and Eggs'},
	{subCategory: 'Packaged Food'},
	{subCategory: 'Cooking Essentials'},

	{subCategory: 'Dogs'},
	{subCategory: 'Cats'},
	{subCategory: 'Fish and Aquatic Pets'},
	{subCategory: 'Birds'},
	{subCategory: 'Reptiles and Amphibians'},
	{subCategory: 'Small Animals'},
	{subCategory: 'Horses'},

	{subCategory: 'Stationery'},
	{subCategory: 'Desk Organizers'},
	{subCategory: 'NoteBooks and Diaries'},
	{subCategory: 'Art Supplies'},
	{subCategory: 'Office Equipments'},
	{subCategory: 'Party Suppllies'},
	{subCategory: 'Fancy Items'},
	{subCategory: 'School Supplies'},

	{subCategory: 'Soft Toys'},
	{subCategory: 'Puzzles'},
	{subCategory: 'Board Games'},
	{subCategory: 'Baby Toys'},
	{subCategory: 'Giftable Toys'},
	{subCategory: 'Electronic Toys'},
	{subCategory: 'Educational Toys'},

	{subCategory: 'Watches'},
	{subCategory: 'Shoes'},
	{subCategory: 'Men\'s Jewelry'},
	{subCategory: 'Women\'s Jewelry'},
	{subCategory: 'Handbags'},
	{subCategory: 'Wallets'},
	{subCategory: 'Watch Accessories'},
	{subCategory: 'Gloves and Mittens'},
	{subCategory: 'Precious Jewelry'},
	{subCategory: 'Belts'},
	{subCategory: 'Sunglasses'},
	{subCategory: 'Contact Lenses and Frames'},
	{subCategory: 'Bags and Luggages'},

	{subCategory: 'Utensils'},
	{subCategory: 'Containers'},
	{subCategory: 'Cookware'},
	{subCategory: 'Kitchen Tools'},
	{subCategory: 'Gas Stoves and Accessories'},
	{subCategory: 'Kitchen Storage'},
	{subCategory: 'Grinders and Juicers'},
	{subCategory: 'Choopers, Cutters and Knives'},
];
